export default __webpack_public_path__ + "static/media/testSeries.ddd1b25a.svg";